// ============================================================================
// ClientLanguageToggle — EN / 繁中 switch for the portal. Same Pulse styling as
// the trainer toggle, but additionally persists the choice to the CLIENT's own
// profile (PATCH /api/client/me) when they're signed in, so the language sticks
// across devices. Falls back to local-only when logged out (claim/login pages).
// ============================================================================
import { useTranslation } from "react-i18next";
import { LOCALE_LABELS, SUPPORTED_LOCALES, setLocale } from "../i18n/config";
import type { Locale } from "../i18n/config";
import { clientApi } from "../api";
import { cn } from "../lib/cn";

export function ClientLanguageToggle({ className }: { className?: string }) {
  const { i18n, t } = useTranslation("clientPortal");
  const active = (i18n.language?.split("-")[0] ?? "en") as Locale;

  const choose = (loc: Locale) => {
    setLocale(loc);
    // Best-effort server persist; ignore failure (logged-out or offline).
    void clientApi.setLocale(loc).catch(() => undefined);
  };

  return (
    <div
      role="group"
      aria-label={t("nav.home")}
      className={cn(
        "inline-flex items-center gap-1 rounded-pill bg-surface-sunken p-1 ring-1 ring-line",
        className,
      )}
    >
      {SUPPORTED_LOCALES.map((loc) => {
        const isActive = active === loc;
        return (
          <button
            key={loc}
            type="button"
            onClick={() => choose(loc)}
            aria-pressed={isActive}
            className={cn(
              "rounded-pill px-2.5 py-1 font-display text-[0.7rem] font-bold transition-colors",
              isActive
                ? "bg-grad-coral text-white shadow-volt"
                : "text-body-soft hover:text-body",
            )}
          >
            {LOCALE_LABELS[loc]}
          </button>
        );
      })}
    </div>
  );
}
